(() => {
  if (customElements.get('abok-about-watch-read')) return;

  class AbokAboutWatchRead extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      document.addEventListener('shopify:block:select', (event) => this.onBlockSelect(event), {
        signal: this.controller.signal,
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    onBlockSelect(event) {
      const block = event.target?.closest?.('[data-watch-read-block]');
      if (!block || !this.contains(block)) return;

      const panelId = block.dataset.watchReadPanelId;
      const tabs = this.querySelector('abok-tabs');
      const tab = tabs?.querySelector(`[data-abok-tab][aria-controls="${CSS.escape(panelId)}"]`);
      if (tab?.getAttribute('aria-selected') !== 'true') tab?.click();
    }
  }

  customElements.define('abok-about-watch-read', AbokAboutWatchRead);
})();
